export default "__VITE_ASSET__D$00CjAh__"